import { IReceiptOrderInfo, IReceiptOrderParams, IReceiptOrderTrace, ISplitEntryRecord, ISplitEntryRecordParam, IUnfreezeReceiptOrderParams } from '../../../types/air-splitting/bill-management/entryRecords';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 账单管理 - 入账记录
 */
export async function querySplitEntryRecords(param: ISplitEntryRecordParam) {
  let data = [] as ISplitEntryRecord[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as ISplitEntryRecordParam;

  try {
    const { code, context, message } = await Http.get<{ data: ISplitEntryRecord[]; total: number }>(`${hostUrl}/pay/deposit-record/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ISplitEntryRecord[]; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 账单管理 - 入账记录解冻
 */
export async function toUnfreeze(depositIdList: Array<string>) {

  try {
    const { code, message } = await Http.post(`${hostUrl}/pay/deposit-record/unfreeze`, { depositIdList });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 账单管理 - 收款订单列表
 */
export async function queryReceiptOrderList(param: IReceiptOrderParams) {
  let data = [] as IReceiptOrderInfo[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IReceiptOrderParams;

  try {
    const { code, context, message } = await Http.post<{ data: IReceiptOrderInfo[]; total: number }>(`${hostUrl}/pay/receipt-order/page-list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IReceiptOrderInfo[]; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 账单管理 - 收款订单导出
 */
export async function exportReceiptOrder(param: IReceiptOrderParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/receipt-order/export`,
      param,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 账单管理 - 收款订单详情
 */
export async function queryReceiptOrderDetail(id: number) {
  let data = {} as any;

  try {
    const { code, context, message } = await Http.get<IReceiptOrderInfo>(`${hostUrl}/pay/receipt-order/detail`, { id });

    if (code === EAxiosResponseCode.Succeed) {

      data = context || {} as any;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 账单管理 - 获取收款订单生命周期
 */
export async function queryReceiptOrderTraces(id: number) {
  let data = [] as IReceiptOrderTrace[];

  try {
    const { code, context, message } = await Http.get<IReceiptOrderTrace[]>(`${hostUrl}/pay/receipt-order/get-traces`, { id });

    if (code === EAxiosResponseCode.Succeed) {

      data = context || [] as IReceiptOrderTrace[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 账单管理 - 解冻公域提现收款订单
 */
export async function toReceiptOrderUnfreeze(params: IUnfreezeReceiptOrderParams) {

  try {
    const { code, message } = await Http.post(`${hostUrl}/pay/receipt-order/unfreeze`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 账单管理 - 财务订单确认
 */
export async function toConfirmOrder(rcptOrderId: number) {

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/receipt-order/confirm`, { rcptOrderId });
    
    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}
